import { CellProps } from "react-table";
import ImageTextCell from "src/components/tables/cells/ImageTextCell";
import TextCell from "src/components/tables/cells/TextCell";
import ActionsCell from "./ActionsCell";
import { ProductType } from "./product-types";

const useProductTableColumns = ({
  onDelete,
}: {
  onDelete: (id: number) => void;
}) => {
  return [
    {
      Header: "Product Name",
      accessor: "name",
      className: "min-w-[180px]",
      Cell: ({
        value,
        row: {
          original: { image },
        },
      }: CellProps<ProductType>) => (
        <ImageTextCell
          imageSrc={image}
          value={value}
          className="items-center justify-center"
        />
      ),
    },
    {
      Header: "Description",
      accessor: "description",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Price (₹)",
      accessor: "price",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Stock Quantity",
      accessor: "stock",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Category",
      accessor: "category",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Actions",
      accessor: "id",
      className: "min-w-[200px]",
      Cell: ({ value }: CellProps<ProductType>) => (
        <ActionsCell value={value} onDelete={() => onDelete(value)} />
      ),
    },
  ];
};

export default useProductTableColumns;
